module.exports = __webpack_public_path__ + "img/img6.6eddc44e.png";